import { useLocoI18n } from 'custom/composables/useLocoI18n';
import CustomInboxTab from './CustomInboxTab.vue';

// Inbox settings tabs the fork adds (see settings/inbox/Settings.vue). Each key is rendered by CustomInboxTab.
export function useCustomInboxTabs() {
  const { t } = useLocoI18n();

  return inbox => {
    const tabs = [{ key: 'loco-replies', name: t('LOCO.INBOX_REPLIES.TAB') }];
    if (inbox?.channel_type === 'Channel::Whatsapp') {
      tabs.push({
        key: 'loco-whatsapp-connection',
        name: t('LOCO.WHATSAPP.CONNECTION.TAB'),
      });
    }
    return tabs;
  };
}

export { CustomInboxTab };
